import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-permission-crud',
  templateUrl: './permission-crud.component.html',
  styleUrls: ['./permission-crud.component.css']
})
export class PermissionCrudComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/permissions/permission-crud/permission-crud.component.ts